import { skuCard_master } from "./skucard_master";
import { skuCard_15 } from "./skucard_15";

let siteId: number = 12;
const tags = document.getElementsByName("eto:site");
siteId = tags.length === 0 ? 12 : +(tags[0] as HTMLMetaElement).content;

let style = skuCard_master;
switch (siteId) {
    case 15: style = { ...skuCard_master, ...skuCard_15 }; break;
    default: style = skuCard_master;
};
export const skuCardStyles = style;